export const createChartMediaQueryRules = (
  breakpoints: Array<{
    minW?: number;
    maxW?: number;
    minH?: number;
    maxH?: number;
    opts: Record<any, any>;
  }>,
) =>
  breakpoints.map(bp => ({
    query: {
      minWidth: bp.minW ?? Number.NEGATIVE_INFINITY,
      minHeight: bp.minH ?? Number.NEGATIVE_INFINITY,
      maxWidth: bp.maxW ?? Number.POSITIVE_INFINITY,
      maxHeight: bp.maxH ?? Number.POSITIVE_INFINITY,
    },
    option: bp.opts,
  }));
